export const BLOG_ENDPOINTS = {
  getBlogsList: "/api/Blog/GetBlogsList",
  getBlogDetailUsingSlug: "/api/Blog/GetBlogDetailUsingSlug",
  getRecentBlogs: "/api/Blog/GetRecentBlogs",
  submitBlogEnquiry: "/api/Blog/SubmitBlogEnquiry",
  saveSubscriber: "/api/Blog/SaveSubscriber",
  saveBlogComment: "/api/Blog/SaveBlogComment",
  getBlogsByAuthor: "/api/Blog/GetBlogsByAuthor",
  getBlogCategories: "/api/Blog/GetBlogCategories",
  getBlogsByCategorySlug: "/api/Blog/GetBlogsByCategorySlug",
  getThingsToDoByMonthList: "/api/Blog/GetThingsToDoByMonthList",
};
